if ($('#sort_able').length > 0) {
    const app = new Vue({
        el: '#sort_able',
        mounted: function() {
        }
    });
}
